import { createUsePaginatedRequest } from "@glow/react/utils/create-use-paginated-request";
import { ZmClient } from "@utils/ZmClient";

export const usePaginatedRequest = createUsePaginatedRequest(ZmClient);
